module.exports = __webpack_public_path__ + "img/attachment.0b601c10.svg";